var $dc4e2c1a20dc1244$exports = {};
$dc4e2c1a20dc1244$exports = {
    "colorSwatchPicker": `Specimene de culoare`,
    "dropzoneLabel": `Zon\u{103} de plasare`,
    "selectPlaceholder": `Selecta\u{21B}i un element`,
    "tableResizer": `Instrument de redimensionare`
};


export {$dc4e2c1a20dc1244$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
